<template>
  <div id="modal-buy" style="display: block;">
    <div class="bg-buy">
      <div class="container">
        <div class="formulario-buy">
          <a href="javascript:;" class="closet" @click="updateIsComparingVehicles">
            <i class="far fa-times-circle "></i>
          </a>
          <div class="box">
            <div class="title-header buttonBackgroundBorder">
              <h3>{{ $t('Comparar Vehículos') }}</h3>
            </div>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col" class="w-25"></th>
                  <th scope="col" class="w-25" v-for="(vehicle, index) in vehicles" :key="index">
                    <a href="#!" class="thumb">
                      <img :src="`${vehicle.photos_count > 0 ? vehicle.photos[0].url : '/img/placeholder-vehicle.jpg'}`">
                      <small>{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}</small>
                    </a>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">{{ $t('Precio') }}</th>
                  <td v-for="(vehicle, index) in vehicles" :key="index">{{ vehicle.selling_price.price.value|numFormat }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t('Tipo') }}</th>
                  <td v-for="(vehicle, index) in vehicles" :key="index">{{ vehicle.body_style }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t('Transmisión') }}</th>
                  <td v-for="(vehicle, index) in vehicles" :key="index">{{ vehicle.transmission_description }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t('Millaje') }}</th>
                  <td v-for="(vehicle, index) in vehicles" :key="index">{{ vehicle.mileage|numFormat }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t('Año') }}</th>
                  <td v-for="(vehicle, index) in vehicles" :key="index">{{ vehicle.year }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t('Color') }}</th>
                  <td v-for="(vehicle, index) in vehicles" :key="index">{{ vehicle.exterior_generic_color }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t('Condición') }}</th>
                  <td v-for="(vehicle, index) in vehicles" :key="index">{{ vehicle.condition|condition }}</td>
                </tr>
                <tr>
                  <th scope="row"></th>
                  <td v-for="(vehicle, index) in vehicles" :key="index">
                    <a href="javascript:;" class="btn badge-primary buttonBackgroundBorder" @click="removeSelectedVehicle(vehicle.id)"><i class="fas fa-times"></i> {{ $t('Remover') }}</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  props: {
    vehicles: { type: Array },
  },
  methods: {
    updateIsComparingVehicles() {
      this.$emit('toggle', false);
    },
    removeSelectedVehicle(vehicleId) {
      this.$emit('remove', vehicleId);
      if (this.vehicles.length < 1) {
        this.updateIsComparingVehicles();
      }
    },
  },
});
</script>

<style scoped>

</style>
